module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/big/4-64369ed3165a1982f9b991b2080ab5e4.webp";